<button
  class="btn btn-default text-start w-100 position-relative text-dark resource-edit-add-field__button"
  *ngIf="!hasPartOfResource"
  [attr.aria-disabled]="addToMainResourceEnabled ? null : 'true'"
  [class.bg-light]="!addToMainResourceEnabled"
  (click)="addField(false)"
>
  {{ label }}
  <span class="position-absolute end-0 me-3"
    ><i class="fa fa-plus" aria-hidden="true"></i
  ></span>
</button>

<div
  class="btn-group position-relative w-100"
  dropdown
  *ngIf="hasPartOfResource"
>
  <button
    aria-controls="dropdown-basic"
    class="btn btn-default dropdown-toggle text-start text-dark resource-edit-add-field__button"
    id="button-basic"
    type="button"
    dropdownToggle
    [attr.aria-disabled]="
      addToMainResourceEnabled || addToPartOfResourceEnabled ? null : 'true'
    "
    [class.bg-light]="!(addToMainResourceEnabled || addToPartOfResourceEnabled)"
  >
    {{ label }}
  </button>
  <ng-container *ngIf="addToMainResourceEnabled || addToPartOfResourceEnabled">
    <ul
      aria-labelledby="button-basic"
      class="dropdown-menu resource-edit-add-field__dropdown"
      id="dropdown-basic"
      role="menu"
      *dropdownMenu
    >
      <li role="menuitem" *ngIf="addToMainResourceEnabled">
        <a
          class="dropdown-item"
          i18n="@@resourceEditAddFieldButton-addToMainResource"
          role="button"
          (click)="addField(false)"
          >Add to main resource</a
        >
      </li>
      <li role="menuitem" *ngIf="addToPartOfResourceEnabled">
        <a
          class="dropdown-item"
          i18n="@@resourceEditAddFieldButton-addToPartOfResource"
          role="button"
          (click)="addField(true)"
          >Add to part of resource</a
        >
      </li>
    </ul>
  </ng-container>
</div>
